/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  vehicleCategoryB: 'vehicleCategoryB',
  vehicleCategoryC: 'vehicleCategoryC',
  vehicleCategoryD: 'vehicleCategoryD',
  vehicleCategoryW: 'vehicleCategoryW',
  vehicleCategoryV: 'vehicleCategoryV',
  vehicleCategoryL: 'vehicleCategoryL',
  vehicleCategoryS: 'vehicleCategoryS',
  vehicleCategoryT: 'vehicleCategoryT',
  vehicleCategoryF: 'vehicleCategoryF',
  vehicleCategoryJ: 'vehicleCategoryJ',
  vehicleCategoryX: 'vehicleCategoryX',
  vehicleCategoryP: 'vehicleCategoryP',
  vehicleCategoryQ: 'vehicleCategoryQ',
  vehicleCategoryZ: 'vehicleCategoryZ',
  vehicleCategoryE: 'vehicleCategoryE',
  vehicleCategoryM: 'vehicleCategoryM',
  vehicleCategoryR: 'vehicleCategoryR',
  vehicleCategoryH: 'vehicleCategoryH',
  vehicleCategoryY: 'vehicleCategoryY',
  vehicleCategoryN: 'vehicleCategoryN',
  vehicleCategoryG: 'vehicleCategoryG',
  vehicleCategoryK: 'vehicleCategoryK',
  vehicleCategoryI: 'vehicleCategoryI',
  vehicleCategoryPKWEC: 'vehicleCategoryPKWEC',
  KILOMETER: 'KILOMETER',
  MILES: 'MILES',
  DAY: 'DAY',
  STAY: 'STAY',
  'N/A': 'N/A',
  true: 'true',
  false: 'false',
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
  BENZIN: 'BENZIN',
  DIESEL: 'DIESEL',
  UNSPECIFIED: 'UNSPECIFIED'
}; export default Keys;